import { put } from 'redux-saga/effects';
import http from "axios/index";

import {
    GET_MANAGERS,
    GET_MANAGER_REQUESTS,
    COST_CONFIRM_REQUEST,
    COST_CANCEL_REQUEST,
    MANAGER_ALL_COST_CONFIRM
} from '../../../api/constants'

import {
    SWAL_ERROR_TITLE,
    SWAL_TYPE_ERROR,
    SWAL_SUCCESS_TITLE,
    SWAL_TYPE_SUCCESS,
    SWAL_TYPE_INFO,
    COST_CONFIRMING_MESSAGE,
    OPERATION_PROCESSING
} from '../../../utils/constants'

import {
    getManagersSuccessful,
    getManagersFailure,
    removeSession,
    getManagerRequestsFailure,
    getManagerRequestsSuccessful
} from '../../actions'

import { swalOpen } from '../../utils';

export function* getManagers({ payload }) {
    try {
        let body = new URLSearchParams();
        body.append("accessToken", payload);
        const response = yield http.post(GET_MANAGERS, body);
        if (!response.data.err) {
            yield put(getManagersSuccessful(response.data.data));
        } else {
            yield put(getManagersFailure(response.data.err));
        }
    } catch (error) {
        yield put(removeSession());
        console.error("Error happened when try to fetch getManagers.Error : ", error)
    }
}

export function* getManagerRequests({ payload }) {
    try {
        const { accessToken, employeeId, month, year, costStatus } = payload
        debugger;
        let body = new URLSearchParams();
        body.append("accessToken", accessToken);
        body.append("employeeId", employeeId);
        body.append("month", month);
        body.append("year", year);
        body.append("costStatus", costStatus);       
        const response = yield http.post(GET_MANAGER_REQUESTS, body);
        debugger;
        if (!response.data.err) {
            yield put(getManagerRequestsSuccessful(response.data.data));
        } else {
            yield put(getManagerRequestsFailure(response.data.err));
            swalOpen(SWAL_ERROR_TITLE, response.data.data, SWAL_TYPE_ERROR, false);
        }
    } catch (error) {
        console.error("Error happened when try to fetch getManagerRequests.Error : ", error)
    }
}

export function* costConfirm({ payload }) {
    try {
        const { user, costData, accessToken, employeeFilter, cb } = payload
        let form = new FormData();
        let costDate = costData.costDate.split("/")
        let month = costDate[1];
        let year = costDate[2];
        let status = costData.status;
        form.append("accessToken", accessToken);
        form.append("employeeId", user._id);
        form.append("costId", costData.costId);
        const response = yield http.put(COST_CONFIRM_REQUEST, form);
        if (!response.data.err) {
            swalOpen(SWAL_SUCCESS_TITLE, response.data.data, SWAL_TYPE_SUCCESS, false);
            const payload = {
                'accessToken': accessToken,
                'employeeId': employeeFilter === '-1' ? employeeFilter : user._id,
                'month': month,
                'year': year,
                'costStatus': "manager"
            }
            yield getManagerRequests({ payload });
        } else {
            swalOpen(SWAL_ERROR_TITLE, response.data.data, SWAL_TYPE_ERROR, false);
        }
    } catch (error) {
        console.error("Error happened when try to fetch getManagerRequests.Error : ", error)
    }
}

export function* costCancel({ payload }) {
    try {
        const { accessToken, user, costData, costDescription } = payload
        let costDate = costData.costDate.split("/")
        let month = costDate[1];
        let year = costDate[2];
        let status = costData.status;
        var form = new URLSearchParams();
        form.append("accessToken", accessToken);
        form.append("employeeId", user._id);
        form.append("costId", costData.costId);
        form.append("description", costDescription);
        const response = yield http.post(COST_CANCEL_REQUEST, form);
        if (!response.data.err) {
            swalOpen(SWAL_SUCCESS_TITLE, response.data.data, SWAL_TYPE_SUCCESS, false);
            const payload = {
                'accessToken': accessToken,
                'employeeId': -1,
                'month': month,
                'year': year,
                'costStatus': "manager"

            }
            yield getManagerRequests({ payload });
        } else {
            swalOpen(SWAL_ERROR_TITLE, response.data.data, SWAL_TYPE_ERROR, false);
        }
    } catch (error) {
        console.error("Error happened when try to fetch getManagerRequests.Error : ", error)
    }
}


export function* confirmAllCosts({ payload }) {
    try {
        swalOpen(OPERATION_PROCESSING, COST_CONFIRMING_MESSAGE, SWAL_TYPE_INFO, false);
        const { accessToken, month, year, costStatus, employeeId } = payload
        let body = new URLSearchParams();
        body.append("month", month);
        body.append("year", year);
        body.append("accessToken", accessToken);
        body.append("employeeId", employeeId);
        const response = yield http.post(MANAGER_ALL_COST_CONFIRM, body);
        if (!response.data.err) {
            swalOpen(SWAL_SUCCESS_TITLE, response.data.data, SWAL_TYPE_SUCCESS, false);
            const payload = {
                'accessToken': accessToken,
                'employeeId': -1,
                'month': month,
                'year': year,
                'costStatus': costStatus
            }
            yield getManagerRequests({ payload });
            yield setTimeout(function () {
                window.location.reload()
              }, 1000);
        } else {
            swalOpen(SWAL_ERROR_TITLE, response.data.data, SWAL_TYPE_ERROR, false);
        }
    } catch (error) {
        console.error("Error happened when try to fetch getManagerRequests.Error : ", error)
    }
}